import type { ReactNode } from 'react';
import { Glyph, type GlyphType } from './Glyph.js';

// Palantir-style empty state. Used for /vendor/$id when canonicalization is
// pending, and elsewhere when an entity has zero records yet.

export function EmptyState({
  glyph,
  reason,
  detail,
  actions,
}: {
  glyph?: GlyphType;
  reason: string;
  detail?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <div className="empty">
      {glyph && <Glyph type={glyph} size={32} />}
      <div className="empty-reason">{reason}</div>
      {detail && <div className="empty-detail">{detail}</div>}
      {actions && <div className="empty-actions">{actions}</div>}
    </div>
  );
}
